export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-12.f2090161.jpg";